var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopirightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5C1 15.7467 5.25329 20 10.5 20Z",
    stroke: "#F7F7F7",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6663 8.38943V8.12554C13.6663 7.63563 13.4717 7.16578 13.1253 6.81936C12.7789 6.47294 12.309 6.27832 11.8191 6.27832H9.44412C8.88422 6.27832 8.34725 6.50074 7.95134 6.89665C7.55543 7.29256 7.33301 7.82953 7.33301 8.38943V12.6117C7.33301 13.1716 7.55543 13.7085 7.95134 14.1044C8.34725 14.5003 8.88422 14.7228 9.44412 14.7228H11.8191C12.309 14.7228 12.7789 14.5281 13.1253 14.1817C13.4717 13.8353 13.6663 13.3655 13.6663 12.8755V12.6117",
    stroke: "#F7F7F7",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopirightIcon);
export default __webpack_public_path__ + "static/media/copirightIcon.a1c5d7f1fa887eac61d13c01ffe1d3bf.svg";
export { ForwardRef as ReactComponent };